const c = {
  name: "Hands01100",
  dimensions: { width: 26, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 26 40" style="enable-background:new 0 0 26 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill-rule:evenodd;clip-rule:evenodd;fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M19.8,14.7c0.6-0.4,1.4-0.7,2.2-0.7c2.2,0,4,1.8,4,4v9c0,7.2-5.8,13-13,13S0,34.2,0,27V6c0-2.2,1.8-4,4-4
			c0.8,0,1.6,0.2,2.2,0.7C6.8,1.1,8.3,0,10,0c2.2,0,4,1.8,4,4v8.5c0.6-0.3,1.3-0.5,2-0.5C17.7,12,19.2,13.1,19.8,14.7z M8,4
			c0-1.1,0.9-2,2-2c1.1,0,2,0.9,2,2v15.5c-0.6-0.3-1.3-0.5-2-0.5H8V4z M13,25.6c0.7,0.8,1.8,1.4,3,1.4c1.7,0,3.2-1.1,3.8-2.7
			c0.6,0.4,1.4,0.7,2.2,0.7c0.7,0,1.4-0.2,2-0.5V27c0,6.1-4.9,11-11,11C6.9,38,2,33.1,2,27v-4c0-1.1,0.9-2,2-2h6c1.1,0,2,0.9,2,2
			s-0.9,2-2,2H6v2h4C11.2,27,12.3,26.5,13,25.6z M20,21c0,1.1,0.9,2,2,2c1.1,0,2-0.9,2-2v-3c0-1.1-0.9-2-2-2c-1.1,0-2,0.9-2,2V21z
			 M18,16c0-1.1-0.9-2-2-2c-1.1,0-2,0.9-2,2v7c0,1.1,0.9,2,2,2c1.1,0,2-0.9,2-2V16z M6,6c0-1.1-0.9-2-2-2C2.9,4,2,4.9,2,6v13.5
			C2.6,19.2,3.3,19,4,19h2V6z"/>
	</g>
</g>
</svg>
  `
};
export {
  c as Hands01100
};
